<template>
    <el-dialog :visible.sync="dialogVisible" width="50%" :show-close="false" @close="handleClose"
        :close-on-click-modal="false">
        <div class="padding-bottom-60">
            <div class="padding-lr-30 flex justify-between align-center solid-bottom h-70 text-main">
                <span class="text-18">{{ wordData?.current_index }}/{{ wordData?.total }}</span>
                <span class="text-20">{{ title }}</span>
                <i class="el-icon-close" @click="handleClose"></i>
            </div>
            <div class="padding-top-30">
                <div class="text-24 text-000-color flex  padding-lr-30">
                    <div class="padding-right-30 flex align-center">
                        <img src="@/assets/icon30.png" class="w-25 h-23" />
                        <span class="text-17 padding-left-6">{{ countdown }}秒</span>
                    </div>
                    
                    <template v-if="!isInReviewCycle">
                        <img v-if="!isPaused" src="@/assets/icon31.png" class="w-25 h-23" @click="pauseCountdown"
                            style="cursor: pointer;" />
                        <i v-else class="el-icon-video-play" style="font-size: 26px; cursor: pointer;"
                            @click="pauseCountdown"></i>
                    </template>
                    <span></span>
                </div>
                <div class="padding-lr-30">
                    <div class="text-30 padding-top-55 margin-bottom-10 " style="color: #001a8b">
                        <img src="@/assets/icon20.png" class="w-44 h-36 margin-right-10" @click="playAudio" />
                        {{
                            wordData?.vocabulary_info?.definition || wordData?.vocabulary_info?.json[0]?.name +
                            wordData?.vocabulary_info?.json[0]?.value
                        }}
                    </div>
                    
                    <div class="text-bold text-left  padding-left-10 text-30"
                        v-if="writtenSilently && shouldShowColorSplit"
                        style="display: flex; flex-wrap: wrap; align-items: center;">
                        <template v-for="(char, index) in splitWord">
                            <span v-if="char.letter === ' '" :key="'space-' + index"
                                :style="{ color: char.color }">&nbsp;</span>
                            <span v-else :key="index" :style="{ color: char.color }">
                                {{ char.letter }}
                            </span>
                        </template>
                    </div>
                    
                    <div class="text-red text-bold text-left  padding-left-10 text-30"
                        v-if="writtenSilently && !shouldShowColorSplit">
                        {{ wordData?.vocabulary_info?.name }}
                    </div>
                    <el-input ref="dictationInput" v-model="writeValue" type="text" placeholder="请输入1"
                        class="dictation-input" @keyup.enter.native="emitEnter" />

                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { submitAnswer, submitReviewAnswer, fetchUserInfo } from "@/api/common";

export default {
    name: "DictationDialog",
    data() {
        return {
            countdown: 5, 
            countdownTimer: null,
            writtenSilently: false,
            localInput: "", 
            isPaused: false, 
            isSubmitting: false, 
            countdownFinished: false, 
            correctCount: 0, 
            isFirstAttempt: true, 
            isInReviewCycle: false, 
            hasCopiedOnce: false, 
            reviewCorrectStreak: 0 
        };
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        wordData: {
            type: Object,
            default: () => ({})
        },
        progress: {
            type: [String, Number],
            default: "1"
        },
        title: {
            type: String,
            default: "2"
        },
        write: {
            type: String,
            default: "2"
        },
        type: {
            type: String,
            default: "1" 
        },
        currentIndex: {
            type: [String, Number],
            default: "1"
        },
        totalWords: {
            type: [String, Number],
            default: 0
        },
        useReviewApi: {
            type: Boolean,
            default: false 
        },
        isPhonicsMode: {
            type: Boolean,
            default: false 
        }
    },
    computed: {
        dialogVisible: {
            get() {
                return this.visible;
            },
            set(value) {
                this.$emit('update:visible', value);
            }
        },
        writeValue: {
            get() {
                return this.localInput || this.write;
            },
            set(value) {
                this.localInput = value;
                this.$emit('update:write', value);
            }
        },
        correctAnswer() {
            return this.wordData?.vocabulary_info?.name || "";
        },
        
        shouldShowColorSplit() {
            
            if (!this.isPhonicsMode) {
                return false;
            }
            
            const array = this.wordData?.vocabulary_info?.array || [];
            return array && array.length > 0;
        },
        
        splitWord() {
            const word = this.wordData?.vocabulary_info?.name || "";
            const array = this.wordData?.vocabulary_info?.array || [];

            if (!word) {
                return [];
            }

            
            const positionColorMap = {};
            
            const occupiedPositions = new Set();
            const wordLower = word.toLowerCase();

            if (array && array.length > 0) {
                
                const multiCharItems = [];
                const singleCharItems = [];

                array.forEach((item) => {
                    if (item.name && item.translation) {
                        if (item.name.length > 1) {
                            multiCharItems.push(item);
                        } else {
                            singleCharItems.push(item);
                        }
                    }
                });

                
                multiCharItems.forEach((item) => {
                    const color = this.getColorFromTranslation(item.translation);
                    const nameLower = item.name.toLowerCase();

                    
                    if (nameLower === wordLower) {
                        for (let i = 0; i < word.length; i++) {
                            positionColorMap[i] = color;
                            occupiedPositions.add(i);
                        }
                    }
                    
                    else if (wordLower.includes(nameLower)) {
                        let searchIndex = 0;
                        
                        while (true) {
                            const startIndex = wordLower.indexOf(nameLower, searchIndex);
                            if (startIndex === -1) break;

                            
                            for (let i = 0; i < nameLower.length; i++) {
                                const pos = startIndex + i;
                                if (pos < word.length) {
                                    positionColorMap[pos] = color;
                                    occupiedPositions.add(pos);
                                }
                            }

                            searchIndex = startIndex + 1;
                        }
                    }
                });

                
                singleCharItems.forEach((item) => {
                    const color = this.getColorFromTranslation(item.translation);
                    const nameLower = item.name.toLowerCase();

                    for (let i = 0; i < word.length; i++) {
                        
                        if (wordLower[i] === nameLower && !occupiedPositions.has(i)) {
                            positionColorMap[i] = color;
                        }
                    }
                });
            }

            
            return word.split("").map((letter, index) => {
                return {
                    letter: letter,
                    color: positionColorMap[index] || "#001a8b" 
                };
            });
        }
    },
    watch: {

        dialogVisible(value) {
            if (value) {
                
                this.loadLearningCountdown().then(() => {
                    
                    this.localInput = "";
                    this.isPaused = false;
                    this.isSubmitting = false;
                    this.countdownFinished = false;
                    this.correctCount = 0; 
                    this.isFirstAttempt = true; 
                    this.isInReviewCycle = false; 
                    this.hasCopiedOnce = false; 
                    this.reviewCorrectStreak = 0; 
                    this.resetCountdown();
                    this.startCountdown();
                    
                    this.$nextTick(() => {
                        this.focusInput();
                    });
                });
            } else {
                
                this.stopCountdown();
                this.writtenSilently = false;
                this.localInput = "";
                this.isPaused = false;
                this.isSubmitting = false;
                this.countdownFinished = false;
                this.correctCount = 0; 
                this.isFirstAttempt = true; 
                this.isInReviewCycle = false; 
                this.hasCopiedOnce = false; 
                this.reviewCorrectStreak = 0; 
            }
        },
        wordData: {
            handler() {
                if (this.dialogVisible) {
                    
                    this.loadLearningCountdown().then(() => {
                        
                        this.localInput = "";
                        this.isPaused = false;
                        this.isSubmitting = false;
                        this.countdownFinished = false;
                        this.correctCount = 0; 
                        this.isFirstAttempt = true; 
                        this.isInReviewCycle = false; 
                        this.hasCopiedOnce = false; 
                        this.reviewCorrectStreak = 0; 
                        this.resetCountdown();
                        this.startCountdown();
                        this.writtenSilently = false;
                        
                        this.$nextTick(() => {
                            this.focusInput();
                        });
                    });
                }
            },
            deep: true
        }
    },
    beforeDestroy() {
        this.stopCountdown();
    },
    methods: {
        playAudio() {
            this.$emit("play-audio", this.wordData);
        },
        
        loadLearningCountdown() {
            
            if (this.wordData?.learningcountdown !== undefined && this.wordData?.learningcountdown !== null) {
                this.countdown = parseInt(this.wordData.learningcountdown);
                return Promise.resolve();
            }
            
            return fetchUserInfo()
                .then((res) => {
                    const learningCountdown = res.data?.learningcountdown;
                    this.countdown = parseInt(learningCountdown);
                    return Promise.resolve();
                })
                .catch((error) => {
                    
                    console.error('获取学习倒计时失败:', error);
                    this.countdown = 5;
                    return Promise.resolve();
                });
        },
        emitEnter(event) {
            this.$emit('enter', event);
        },
        handleClose() {
            this.$emit('close');
        },
        handleStartTest() {
            this.$emit('start-test');
        },
        startCountdown() {
            this.stopCountdown();
            this.isPaused = false;
            this.countdownTimer = setInterval(() => {
                if (!this.isPaused) {
                    if (this.countdown > 0) {
                        this.countdown--;
                    } else {
                        
                        this.stopCountdown();
                        this.countdownFinished = true; 

                        
                        const hasInput = this.writeValue && this.writeValue.trim();
                        const isCorrect = hasInput && this.checkAnswer();

                        if (!hasInput || !isCorrect) {
                            
                            this.submitAnswerOnceAndStartReviewCycle();
                        } else {
                            
                            this.submitAnswerOnce();
                        }
                    }
                }
            }, 1000);
        },
        stopCountdown() {
            if (this.countdownTimer) {
                clearInterval(this.countdownTimer);
                this.countdownTimer = null;
            }
        },
        resetCountdown() {
            this.stopCountdown();
            
            
            if (!this.countdown || this.countdown <= 0) {
                this.countdown = 5;
            }
            this.isPaused = false; 
        },
        pauseCountdown() {
            
            this.isPaused = !this.isPaused;
            
            this.$nextTick(() => {
                this.focusInput();
            });
        },
        checkAnswer() {
            
            const userInput = (this.writeValue || "").trim().toLowerCase();
            const correct = (this.correctAnswer || "").trim().toLowerCase();

            
            if (userInput !== correct && correct) {
                this.writtenSilently = true;
                
                this.$forceUpdate();
                return false; 
            }
            
            this.writtenSilently = false;
            return true; 
        },
        
        submitAnswerOnceAndStartReviewCycle() {
            if (this.isSubmitting) {
                return; 
            }

            this.isSubmitting = true;

            
            const answer = (this.writeValue || "").trim();

            
            if (this.useReviewApi) {
                
                const difficultStudyId = this.wordData?.difficult_study_id || this.wordData?.info?.id;

                if (!difficultStudyId) {
                    this.$message.error("数据不完整，无法提交答案");
                    this.isSubmitting = false;
                    return;
                }

                submitReviewAnswer({
                    type: this.type,
                    difficultStudyId: difficultStudyId.toString(),
                    currentIndex: this.currentIndex.toString(),
                    action: "0", 
                    answer: answer
                }).then((res) => {
                    
                    this.isSubmitting = false;
                    this.writtenSilently = true;
                    
                    this.isInReviewCycle = true;
                    this.hasCopiedOnce = false;
                    this.reviewCorrectStreak = 0;
                    this.writtenSilently = true;
                    this.stopCountdown();
                }).catch((error) => {
                    this.isSubmitting = false;
                    this.$message.error("提交答案失败，请稍后重试");
                    console.error("提交答案错误:", error);
                });
            } else {
                
                const difficultStudyId = this.wordData?.info?.id;
                const difficultVocabularyId = this.wordData?.info?.difficult_vocabulary_id;

                if (!difficultStudyId || !difficultVocabularyId) {
                    this.$message.error("数据不完整，无法提交答案");
                    this.isSubmitting = false;
                    return;
                }

                submitAnswer({
                    type: this.type,
                    difficultStudyId: difficultStudyId.toString(),
                    difficultVocabularyId: difficultVocabularyId.toString(),
                    currentIndex: this.currentIndex.toString(),
                    action: "0", 
                    answer: answer
                }).then((res) => {
                    this.writeValue = '';
                    
                    this.isSubmitting = false;
                    this.writtenSilently = true;
                    
                    this.isInReviewCycle = true;
                    this.hasCopiedOnce = false;
                    this.reviewCorrectStreak = 0;
                    this.writtenSilently = true;
                    this.stopCountdown();
                }).catch((error) => {
                    this.isSubmitting = false;
                    this.$message.error("提交答案失败，请稍后重试");
                    console.error("提交答案错误:", error);
                });
            }
        },
        
        submitAnswerOnce() {
            if (this.isSubmitting) {
                return; 
            }

            this.isSubmitting = true;

            
            const answer = (this.writeValue || "").trim();

            
            if (this.useReviewApi) {
                
                const difficultStudyId = this.wordData?.difficult_study_id || this.wordData?.info?.id;

                if (!difficultStudyId) {
                    this.$message.error("数据不完整，无法提交答案");
                    this.isSubmitting = false;
                    return;
                }

                submitReviewAnswer({
                    type: this.type,
                    difficultStudyId: difficultStudyId.toString(),
                    currentIndex: this.currentIndex.toString(),
                    action: "0", 
                    answer: answer 
                }).then((res) => {
                    
                    this.isSubmitting = false;
                    this.writtenSilently = true;
                    
                }).catch((error) => {
                    this.isSubmitting = false;
                    this.$message.error("提交答案失败，请稍后重试");
                    console.error("提交答案错误:", error);
                });
            } else {
                
                const difficultStudyId = this.wordData?.info?.id;
                const difficultVocabularyId = this.wordData?.info?.difficult_vocabulary_id;

                if (!difficultStudyId || !difficultVocabularyId) {
                    this.$message.error("数据不完整，无法提交答案");
                    this.isSubmitting = false;
                    return;
                }

                submitAnswer({
                    type: this.type,
                    difficultStudyId: difficultStudyId.toString(),
                    difficultVocabularyId: difficultVocabularyId.toString(),
                    currentIndex: this.currentIndex.toString(),
                    action: "0", 
                    answer: answer 
                }).then((res) => {
                    this.writeValue = '';
                    
                    this.isSubmitting = false;
                    this.writtenSilently = true;
                    
                }).catch((error) => {
                    this.isSubmitting = false;
                    this.$message.error("提交答案失败，请稍后重试");
                    console.error("提交答案错误:", error);
                });
            }
        },
        
        submitAnswerUntilSuccess() {
            if (this.isSubmitting) {
                return; 
            }

            this.isSubmitting = true;
            const difficultStudyId = this.wordData?.info?.id;
            const difficultVocabularyId = this.wordData?.info?.difficult_vocabulary_id;

            if (!difficultStudyId || !difficultVocabularyId) {
                this.$message.error("数据不完整，无法提交答案");
                this.isSubmitting = false;
                return;
            }

            const maxRetries = 10; 
            let retryCount = 0;

            const submit = () => {
                submitAnswer({
                    type: this.type,
                    difficultStudyId: difficultStudyId.toString(),
                    difficultVocabularyId: difficultVocabularyId.toString(),
                    currentIndex: this.currentIndex.toString(),
                    action: "0", 
                    answer: (this.writeValue || "").trim() 
                }).then((res) => {
                    this.writeValue = '';
                    
                    if (res.data?.answer_status === true) {
                        
                        this.isSubmitting = false;
                        this.$emit('next', res.data);
                        this.writtenSilently = false;
                        this.localInput = "";
                        this.isPaused = false;
                        this.resetCountdown();
                    } else {
                        
                        retryCount++;
                        if (retryCount < maxRetries) {
                            
                            setTimeout(() => {
                                submit();
                            }, 500);
                        } else {
                            
                            this.isSubmitting = false;
                            this.$message.error("提交答案失败，已达到最大重试次数");
                        }
                    }
                }).catch((error) => {
                    
                    retryCount++;
                    if (retryCount < maxRetries) {
                        setTimeout(() => {
                            submit();
                        }, 500);
                    } else {
                        this.isSubmitting = false;
                        this.$message.error("提交答案失败，请稍后重试");
                        console.error("提交答案错误:", error);
                    }
                });
            };

            
            submit();
        },
        handleEnter() {
            
            if (this.isInReviewCycle) {
                const isCorrect = this.checkAnswer();
                if (isCorrect) {
                    
                    if (!this.hasCopiedOnce) {
                        this.hasCopiedOnce = true;
                        this.writeValue = '';
                        this.localInput = "";
                        this.$message.success("抄写正确！现在需要再连续默写2遍都正确才能进入下一个单词");
                        
                        this.loadLearningCountdown().then(() => {
                            this.resetCountdown();
                            this.startCountdown();
                        });
                        return;
                    }

                    
                    this.reviewCorrectStreak++;
                    this.writeValue = '';
                    this.localInput = "";

                    
                    if (this.reviewCorrectStreak >= 2) {
                        
                        this.isInReviewCycle = false;
                        this.hasCopiedOnce = false;
                        this.reviewCorrectStreak = 0;
                        
                        this.$emit('next', { answer_status: true });
                    } else {
                        
                        const remaining = 2 - this.reviewCorrectStreak;
                        this.$message.success(`答案正确！还需要再连续默写 ${remaining} 遍都正确才能进入下一个单词`);
                        
                        this.loadLearningCountdown().then(() => {
                            this.resetCountdown();
                            this.startCountdown();
                        });
                    }
                } else {
                    
                    this.writtenSilently = true;
                    this.writeValue = '';
                    this.localInput = "";
                    this.reviewCorrectStreak = 0;
                    
                    if (this.hasCopiedOnce) {
                        this.hasCopiedOnce = false;
                        this.$message.warning("答案错误，请重新抄写正确答案");
                    } else {
                        this.$message.warning("答案错误，请重新输入");
                    }

                    
                    this.stopCountdown();
                }
                return;
            }

            
            
            
            
            

            
            const isCorrect = this.checkAnswer();

            
            const difficultStudyId = this.wordData?.info?.id;
            const difficultVocabularyId = this.wordData?.info?.difficult_vocabulary_id;

            if (!difficultStudyId || !difficultVocabularyId) {
                this.$message.error("数据不完整，无法提交答案");
                return;
            }

            
            if (this.countdownFinished) {
                
                submitAnswer({
                    type: this.type,
                    difficultStudyId: difficultStudyId.toString(),
                    difficultVocabularyId: difficultVocabularyId.toString(),
                    currentIndex: this.currentIndex.toString(),
                    action: "0", 
                    answer: this.writeValue.trim()
                }).then((res) => {
                    this.writeValue = '';
                    
                    this.isSubmitting = false;

                    
                    if (res.data?.answer_status === true) {
                        
                        
                        if (this.isFirstAttempt) {
                            
                            const currentIdx = parseInt(this.currentIndex || "1");
                            const total = parseInt(this.totalWords || "0");
                            const isLastWord = currentIdx === total && total > 0;

                            if (isLastWord) {
                                
                                this.$emit('next', res.data);
                            } else {
                                
                                this.$emit('next', res.data);
                            }
                            
                            this.isFirstAttempt = true;
                            this.correctCount = 0;
                            return;
                        }

                        
                        this.correctCount++;

                        
                        this.localInput = "";
                        this.writtenSilently = false;
                        this.countdownFinished = false;

                        
                        if (this.correctCount >= 3) {
                            
                            const currentIdx = parseInt(this.currentIndex || "1");
                            const total = parseInt(this.totalWords || "0");
                            const isLastWord = currentIdx === total && total > 0;

                            if (isLastWord) {
                                
                                this.$emit('next', res.data);
                            } else {
                                
                                this.$emit('next', res.data);
                            }

                            
                            this.correctCount = 0;
                        } else {
                            
                            const remaining = 3 - this.correctCount;
                            this.writeValue = '';
                            
                            const actionText = this.writtenSilently ? '抄写' : '默写';
                            this.$message.success(`答案正确！还需要再正确${actionText} ${remaining} 次`);
                        }
                    } else {
                        
                        this.isFirstAttempt = false;
                        this.correctCount = 0;
                        this.writtenSilently = true;
                        this.isInReviewCycle = true;
                        this.hasCopiedOnce = false;
                        this.reviewCorrectStreak = 0;
                        
                        const correctAnswer = res.data?.correct_answer;
                        
                        this.stopCountdown();
                        if (correctAnswer) {
                            this.$message.warning(`答案错误，正确答案是：${correctAnswer}，请重新输入`);
                        } else {
                            this.$message.warning("答案错误，请重新输入");
                        }
                        
                        this.localInput = "";
                        this.countdownFinished = false;
                    }
                });
                return;
            }

            
            
            submitAnswer({
                type: this.type,
                difficultStudyId: difficultStudyId.toString(),
                difficultVocabularyId: difficultVocabularyId.toString(),
                currentIndex: this.currentIndex.toString(),
                action: "0", 
                answer: this.writeValue.trim()
            }).then((res) => {
                this.writeValue = '';
                
                if (res.data?.answer_status === true) {
                    
                    
                    if (this.isFirstAttempt) {
                        
                        const currentIdx = parseInt(this.currentIndex || "1");
                        const total = parseInt(this.totalWords || "0");
                        const isLastWord = currentIdx === total && total > 0;

                        if (isLastWord) {
                            
                            this.$emit('next', res.data);
                        } else {
                            
                            this.$emit('next', res.data);
                        }
                        
                        this.isFirstAttempt = true;
                        this.correctCount = 0;
                        return;
                    }

                    
                    
                    this.correctCount++;

                    
                    this.localInput = "";
                    this.writtenSilently = false;
                    this.countdownFinished = false;

                    
                    if (this.correctCount >= 3) {
                        
                        const currentIdx = parseInt(this.currentIndex || "1");
                        const total = parseInt(this.totalWords || "0");
                        const isLastWord = currentIdx === total && total > 0;

                        if (isLastWord) {
                            
                            this.$emit('next', res.data);
                        } else {
                            
                            this.$emit('next', res.data);
                        }

                        
                        this.correctCount = 0;
                    } else {
                        this.writeValue = '';
                        
                        const actionText = this.writtenSilently ? '抄写' : '默写';
                        const remaining = 3 - this.correctCount;
                        this.$message.success(`答案正确！还需要再正确${actionText} ${remaining} 次`);
                    }
                } else {
                    
                    this.stopCountdown();
                    
                    this.isFirstAttempt = false;
                    this.correctCount = 0;
                    this.writtenSilently = true;
                    
                    this.isInReviewCycle = true;
                    this.hasCopiedOnce = false;
                    this.reviewCorrectStreak = 0;
                    
                    const correctAnswer = res.data?.correct_answer;
                    
                    this.stopCountdown();
                    if (correctAnswer) {
                        this.$message.warning(`答案错误，正确答案是：${correctAnswer}，请重新输入`);
                    } else {
                        this.$message.warning("答案错误，请重新输入");
                    }
                    
                    this.localInput = "";
                    this.countdownFinished = false;
                }
            }).catch((error) => {
                this.$message.error("提交答案失败，请稍后重试");
            });
        },
        nextStop() {
            
            this.checkAnswer();

            
            this.$emit('next');
            this.writtenSilently = false;
            this.localInput = "";
            this.isPaused = false;
            this.resetCountdown();
        },
        
        focusInput() {
            if (this.$refs.dictationInput) {
                const inputElement = this.$refs.dictationInput.$el?.querySelector('input') || this.$refs.dictationInput.$el;
                if (inputElement) {
                    inputElement.focus();
                }
            }
        },
        
        getColorFromTranslation(translation) {
            const colorMap = {
                "red": "#cc0000",      
                "yellow": "#d4af37",   
                "green": "green",      
                "blue": "#0000cc",     
                "purple": "#800080",   
                "orange": "#ffa500",   
                "cyan": "#008080"      
            };

            
            const lowerTranslation = (translation || "").toLowerCase().trim();
            return colorMap[lowerTranslation] || "#001a8b"; 
        }
    }
};
</script>
<style scoped>
.el-dialog__wrapper {
    background-color: rgba(0, 0, 0, 0.7) !important;
}
</style>
<style scoped lang="scss">
::v-deep {

    .el-dialog__header,
    .el-dialog__body {
        padding: 0 !important;

    }

    .el-dialog {
        border-radius: 30px;
        background: linear-gradient(#ffffff 15%, #e8edff 100%);
        box-shadow: none;
    }
}

.solid-bottom {
    border-bottom: 1px solid #2342c9;

}

.el-icon-close {
    color: #2342c9 !important;
}

::v-deep {
    .el-input {
        font-size: 30px;
        font-weight: bold;
    }

    .dictation-input .el-input__inner {

        height: 54px;
        border-radius: 7px;
    }
}

@media (max-height: 600px) {
    ::v-deep .el-dialog {
        margin-top: 1vh !important;
        margin-bottom: 1vh !important;
        width: 95% !important;
        max-height: 98vh;

        .el-dialog__body {
            max-height: calc(98vh - 40px);
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
        }
    }

    .padding-bottom-60 {
        padding-bottom: 100px !important;
    }

    .padding-top-30 {
        padding-top: 10px !important;
    }

    .padding-top-55 {
        padding-top: 15px !important;
    }

    .margin-bottom-100 {
        margin-bottom: 20px !important;
    }

    .text-30 {
        font-size: 18px !important;
    }

    .text-24 {
        font-size: 16px !important;
    }

    .text-20 {
        font-size: 15px !important;
    }

    .text-18 {
        font-size: 14px !important;
    }

    .text-17 {
        font-size: 13px !important;
    }

    .h-70 {
        height: 45px !important;
    }

    .w-25 {
        width: 18px !important;
    }

    .h-23 {
        height: 16px !important;
    }

    .w-44 {
        width: 28px !important;
    }

    .h-36 {
        height: 22px !important;
    }

    ::v-deep .dictation-input .el-input__inner {
        height: 40px !important;
        font-size: 18px !important;
    }

    
    .padding-lr-30 {
        padding-left: 15px !important;
        padding-right: 15px !important;
    }

    .padding-top-10 {
        padding-top: 8px !important;
    }

    .padding-left-10 {
        padding-left: 8px !important;
    }
}

@media (max-height: 450px) {
    ::v-deep .el-dialog {
        margin-top: 0.5vh !important;
        margin-bottom: 0.5vh !important;

        .el-dialog__body {
            max-height: calc(99vh - 35px);
        }
    }

    .padding-bottom-60 {
        padding-bottom: 120px !important;
    }

    .padding-top-30 {
        padding-top: 8px !important;
    }

    .padding-top-55 {
        padding-top: 12px !important;
    }

    .margin-bottom-100 {
        margin-bottom: 15px !important;
    }

    .text-30 {
        font-size: 16px !important;
    }

    .text-24 {
        font-size: 14px !important;
    }

    .h-70 {
        height: 40px !important;
    }

    ::v-deep .dictation-input .el-input__inner {
        height: 36px !important;
        font-size: 16px !important;
    }
}
</style>
